{
  "boxes": {
    "title": "Boxes",
    "add": "Add box",
    "columns": {
      "name": "Name",
      "code": "Code",
      "branch": "Branch",
      "balance": "Current balance",
      "status": "Status"
    },
    "rowActions": {
      "trigger": "Actions for {{name}}",
      "ledger": "Movement statement",
      "addBalance": "Add balance",
      "withdrawBalance": "Withdraw balance",
      "moveBalance": "Move balance"
    },
    "statusConfirmTitle": "Confirm status change",
    "statusConfirmDeactivateNote": "Disabling this box only blocks it from new use; its previous history is kept as is.",
    "deleteConfirmTitle": "Confirm deletion",
    "deleteConfirmDescription": "The box \"{{name}}\" will be deleted. This action cannot be undone.",
    "deleted": "The box was deleted successfully",
    "statusChanged": "The box's status was changed successfully",
    "drawer": {
      "createTitle": "Add box",
      "editTitle": "Edit box",
      "createDescription": "Enter the new box's details.",
      "editDescription": "Edit the box's details.",
      "created": "The box was created successfully",
      "updated": "The box was updated successfully",
      "fields": {
        "branch": "Branch",
        "name": "Name",
        "code": "Code",
        "openingBalance": "Opening balance"
      }
    }
  },
  "bankAccounts": {
    "title": "Bank accounts",
    "add": "Add bank account",
    "columns": {
      "bankName": "Bank name",
      "accountName": "Account name",
      "accountNumber": "Account number / IBAN",
      "branches": "Allowed branches",
      "balance": "Current balance",
      "status": "Status"
    },
    "rowActions": {
      "trigger": "Actions for {{name}}",
      "ledger": "Movement statement",
      "addBalance": "Add balance",
      "withdrawBalance": "Withdraw balance",
      "moveBalance": "Move balance"
    },
    "statusConfirmTitle": "Confirm status change",
    "statusConfirmDeactivateNote": "Disabling this account only blocks it from new use; its previous history is kept as is.",
    "deleteConfirmTitle": "Confirm deletion",
    "deleteConfirmDescription": "The account \"{{name}}\" will be deleted. This action cannot be undone.",
    "deleted": "The bank account was deleted successfully",
    "statusChanged": "The bank account's status was changed successfully",
    "drawer": {
      "createTitle": "Add bank account",
      "editTitle": "Edit bank account",
      "createDescription": "Enter the new bank account's details.",
      "editDescription": "Edit the bank account's details.",
      "created": "The bank account was created successfully",
      "updated": "The bank account was updated successfully",
      "accountNumberOrIban": "Enter the account number or the IBAN",
      "fields": {
        "bankName": "Bank name",
        "accountName": "Account name",
        "accountNumber": "Account number",
        "iban": "IBAN",
        "branches": "Allowed branches",
        "openingBalance": "Opening balance"
      },
      "invalidIban": "Enter a valid IBAN"
    }
  },
  "validation": {
    "amountDecimals": "Amount must not have more than five decimals",
    "dateNotFuture": "Date must not be in the future"
  },
  "balanceAdjust": {
    "titleIn": "Add balance",
    "titleOut": "Withdraw balance",
    "descriptionIn": "Add a manual balance to {{holder}}.",
    "descriptionOut": "Withdraw a manual balance from {{holder}}.",
    "currentBalance": "Current balance: {{balance}}",
    "resultingBalance": "Balance after this operation: {{balance}}",
    "fields": {
      "amount": "Amount",
      "reason": "Reason",
      "date": "Date"
    },
    "commitIn": "Add balance",
    "commitOut": "Withdraw balance",
    "addedSuccess": "The balance was added successfully",
    "withdrawnSuccess": "The balance was withdrawn successfully"
  },
  "balanceMove": {
    "title": "Move balance",
    "description": "Move a balance between a box and a bank account.",
    "from": "From",
    "to": "To",
    "resultingBalanceFrom": "{{holder}}'s balance after this operation: {{balance}}",
    "resultingBalanceTo": "{{holder}}'s balance after this operation: {{balance}}",
    "fields": {
      "amount": "Amount",
      "reason": "Reason",
      "to": "To"
    },
    "commit": "Move balance",
    "success": "The balance was moved successfully"
  },
  "ledger": {
    "back": "Back",
    "currentBalance": "Current balance: {{balance}}",
    "export": "Export to Excel",
    "exporting": "Exporting...",
    "columns": {
      "date": "Date",
      "type": "Type",
      "in": "In",
      "out": "Out",
      "balanceAfter": "Balance after",
      "employee": "Employee",
      "customer": "Customer",
      "reference": "Reference",
      "reason": "Reason"
    },
    "filters": {
      "from": "From date",
      "to": "To date",
      "type": "Type",
      "allTypes": "All types"
    },
    "types": {
      "OPENING": "Opening balance",
      "TRANSFER": "Transfer",
      "TRANSFER_CANCEL": "Transfer cancellation",
      "TRANSFER_EDIT": "Transfer edit",
      "ADJUST_IN": "Add balance",
      "ADJUST_OUT": "Withdraw balance",
      "MOVE": "Move balance"
    }
  }
}
